import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { Download, UserPlus } from 'lucide-react';
import { DiscordIcon } from './DiscordIcon';
import { LOGO, REGISTER_URL, DOWNLOAD_URL, DISCORD_URL } from '../data/horizon';
const btnBase = 'inline-flex h-7 md:h-10 items-center justify-center gap-1 md:gap-2 rounded-full px-2.5 md:px-5 font-cinzel text-[11px] md:text-sm font-bold whitespace-nowrap transition-colors duration-150 [&>svg]:h-3 [&>svg]:w-3 md:[&>svg]:h-4 md:[&>svg]:w-4';
const discordBtn = `${btnBase} border border-[#5865F2]/50 bg-[#5865F2]/15 text-white hover:bg-[#5865F2]/30`;
const registerBtn = `${btnBase} bg-[#D4AF37] text-[#050b14] hover:bg-[#E3C158]`;
const downloadBtn = `${btnBase} border border-[#D4AF37]/50 text-[#D4AF37] hover:bg-[#D4AF37]/10`;
const mBase = 'inline-flex h-7 items-center justify-center gap-1 rounded-full px-2.5 font-cinzel text-[10px] font-bold whitespace-nowrap transition-colors duration-150 [&>svg]:hidden min-[380px]:[&>svg]:block';
const mDiscord = `${mBase} border border-[#5865F2]/50 bg-[#5865F2]/15 text-white`;
const mDownload = `${mBase} border border-[#D4AF37]/50 text-[#D4AF37]`;
const mRegister = `${mBase} bg-[#D4AF37] text-[#050b14]`;
const sectionLinks = [{
  to: '/guia',
  label: 'Guía'
}, {
  to: '/proyeccion',
  label: 'Proyección'
}];
export function SiteNav() {
  const [hidden, setHidden] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const lastY = useRef(0);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const delta = y - lastY.current;
      setScrolled(y > 24);
      if (y < 80) setHidden(false);else if (delta > 6) setHidden(true);else if (delta < -6) setHidden(false);
      lastY.current = y;
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <motion.header initial={false} animate={{
    y: hidden ? '-100%' : '0%'
  }} transition={{
    duration: reduceMotion ? 0 : 0.22,
    ease: [0.23, 1, 0.32, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-200 ${scrolled ? 'border-white/10 bg-[#050b14]/90 backdrop-blur-md' : 'border-transparent bg-[#050b14]/40 md:bg-transparent'}`} data-id="element-1136" data-mp="1pavhgdis5f7r">
      <nav aria-label="Principal" className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-2 md:py-3" data-id="element-1137" data-mp="16edgr6lye4zd">
        <div className="flex items-center justify-between gap-2 md:gap-3" data-id="element-1138" data-mp="11kj3om0uso99">
          <div className="flex shrink-0 items-center gap-8" data-id="element-1139" data-mp="wo0y5jxp8lvv">
            <Link to="/" aria-label="MU Vanguard — Inicio" className="shrink-0" data-id="element-1140" data-mp="sle5xhx48yy5">
              <img src={LOGO} alt="MU Vanguard" className="h-8 md:h-14 w-auto object-contain" data-id="element-1141" data-mp="sjkulpbk5qjt" />
            </Link>
            <ul className="hidden lg:flex items-center gap-1" data-id="element-1142" data-mp="in81asjxdepl">
              {sectionLinks.map(l => <li key={l.to} data-id="element-1143" data-mp="2uatp5qh11y1g">
                  <NavLink to={l.to} className={({
                isActive
              }) => {
                return `rounded-full px-4 py-2 font-cinzel text-sm font-bold transition-colors duration-150 ${isActive ? 'bg-white/10 text-[#D4AF37]' : 'text-gray-300 hover:text-white'}`;
              }} data-id="element-1144" data-mp="2u9id73dfhjz9">
                    {l.label}
                  </NavLink>
                </li>)}
            </ul>
          </div>
          {/* Móvil: una sola fila compacta */}
          <div className="flex min-w-0 flex-1 items-center justify-end gap-1.5 md:hidden" data-id="element-1145" data-mp="2gjok28uw4djq">
            <a href={DISCORD_URL} target="_blank" rel="noopener noreferrer" className={mDiscord} data-id="element-1146" data-mp="2kjytxwlszo3v">
              <DiscordIcon className="h-3 w-3" data-id="element-1147" data-mp="2pc9zpg38644c" />
              Discord
            </a>
            <a href={DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" className={mDownload} data-id="element-1148" data-mp="1ssj8w6zwa9fr">
              <Download className="h-3 w-3" aria-hidden="true" data-id="element-1149" data-mp="1wu4h3f1hhzjm" />
              Descargar
            </a>
            <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer" className={mRegister} data-id="element-1150" data-mp="1drcckp6p7uq0">
              <UserPlus className="h-3 w-3" aria-hidden="true" data-id="element-1151" data-mp="18ssoai4mu6uh" />
              Crear cuenta
            </a>
          </div>
          <div className="hidden items-center gap-3 md:flex" data-id="element-1152" data-mp="1nhowcf6ovjv3">
            <a href={DISCORD_URL} target="_blank" rel="noopener noreferrer" className={discordBtn} data-id="element-1153" data-mp="1iombqwjw3kr1">
              <DiscordIcon className="h-4 w-4" data-id="element-1154" data-mp="1wg0v54hplnym" />
              Únete a Discord
            </a>
            <a href={DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" className={downloadBtn} data-id="element-1155" data-mp="1riqzv87n2i2v">
              <Download className="h-4 w-4" aria-hidden="true" data-id="element-1156" data-mp="26e6upfg1mi0b" />
              Descargar
            </a>
            <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer" className={registerBtn} data-id="element-1157" data-mp="21h6q78yudnbb">
              <UserPlus className="h-4 w-4" aria-hidden="true" data-id="element-1158" data-mp="c2087khp8esp" />
              Crear mi cuenta
            </a>
          </div>
        </div>
      </nav>
    </motion.header>;
}